import React from 'react';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';

export const Unauthorized = () => {
    return (
        <div
            id="app"
            className={classNamesPrefixed({
                'main-layout': true
            })}
        >
            <div id="root">
                <div className={classNamesPrefixed({'unauthorized': true})}>You don't have access to this page.</div>
            </div>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/core/admin/components/UI/Unauthorized.js